import React, { useState } from 'react';
export const CategoryChips = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', 'Music', 'Podcasts', 'MrBeast', 'Gaming', 'AI', 'Live', 'Reaction videos', 'Crypto', 'Recently uploaded', 'New to you', 'Watched'];
  return <div className="flex overflow-x-auto py-3 -mx-4 px-4 md:px-0 md:-mx-0 no-scrollbar sticky top-14 bg-[#0f0f0f] z-10" data-id="element-121">
      {categories.map((category, index) => <button key={index} onClick={() => setSelectedCategory(category)} className={`flex-shrink-0 px-3 py-1.5 rounded-lg mr-3 text-sm whitespace-nowrap ${selectedCategory === category ? 'bg-white text-black' : 'bg-[#272727] text-white hover:bg-[#3f3f3f]'}`} data-id="element-122">
          {category}
        </button>)}
      <style jsx data-id="element-123">{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};